import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

// You can use two classes types for giving the css defined by you in classes props. 
// Eg. classes = {{drop: 'dropDown'}}. 
// In this example First part is the element which you want to give a new class. and second part is the class name which will be applied to that element.
// In this component two options are there to provide the classes 1. drop 2. option.
// As the names defined these elements are for dropbox and options dropdown respectively.
// Eg. <NewDropSelector classes = {{drop: 'dropDown', option: 'optionDown'}} />


export default class NewDropSelector extends Component {
	constructor(props){
		super(props);
		this.state={
			options:[],
			selected: null,
			search: '',
		}
		this.getOptions = this.getOptions.bind(this);
	}

	componentDidMount() {
		this.setState({
			options: this.props.options,
			selected: this.props.selected
		})
	}

	componentWillReceiveProps(nextProps) {
  		if (nextProps.selected !== this.state.selected) {
    		this.setState({ selected: nextProps.selected});
  		}
  		if (nextProps.options !== this.state.options) {
  			this.setState({options: nextProps.options});
  		}
	}


	getClass(type) {
		if(this.props.classes) {
			if(this.props.classes[type]) {
				return this.props.classes[type];
			}
		}
		return '';
	}

	//<!---------------------------- Calling Parent Method ----------------------------!>
	onSelection(dat) {
		this.setState({selected: dat});
		this.props.selctionChange(dat);
	}	

	//<!---------------------------- Populating options ----------------------------!>
	getOptions() {
		const { search, options } = this.state;
		const { showInput } = this.props;

		if(showInput) {
			
			let s = this.state.search.toLowerCase();
			let facilities = options;
			if (options) {
				var fac = options;
				facilities = options
					.filter((f) => {
						return f.facilityName.toLowerCase().includes(s);
					});
			} else {
				facilities = (
					<CircularProgress
						size={30}
						thickness={5}
						style={{ color: '#212121' }}
					/>
				);
			}
			return (
				<div>
					{facilities.map((facility, index) => {
						return (
							<li 
								className={"dropdown-data-rec "+(this.getClass('option')) + (facility.disabled? 'blocked-option-box' : '')} 
								key={index} 
								onClick={(e) => {if(facility.disabled){e.preventDefault()}else{this.onSelection(facility)}}}
							>
								<div className="dropdown-data-rec-inner">{facility.facilityName}</div>
							</li>
						);
					})
				}
				</div>
			);

		} else {
			var data = this.state.options.map((option, index) => {
				return <li className={"dropdown-data-rec "+(this.getClass('option')) + (option.disabled? 'blocked-option-box' : '')} key={index} onClick={(e) => {if(option.disabled){e.preventDefault()}else{this.onSelection(option)}}}>
					<div className="dropdown-data-rec-inner">{this.props.value ? option[this.props.value]:option}</div>
				</li>
			})
			return data;
		}
	}

	render() {
		return(
			<div style={{position: 'relative'}}>
				{(this.props.disabled)?
					<div className="blocked-selection-box"></div>:null
				}
				<div className="dropdown">
					<div className={"new-drop-date drop-date-wider "+(this.getClass('drop'))} data-toggle="dropdown" style={{textAlign:'left'}}>
						<div>
							{(this.state.selected) ? 
							<span>{this.props.value ? this.state.selected[this.props.value]: this.state.selected}</span> : 
							
							<span style={{opacity: '0.5'}}>{this.props.type}</span>
							}
						<span className="pull-right"><i className="fas fa-angle-down eighteen-font"></i></span>
						</div>
					</div>
					<ul className="dropdown-menu rec-dropdown" style={{width: '100%'}}>
					{
						(this.props.showInput) ? 

						<div>
							<input
								className='facility-search'
								type='text'
								value={this.state.search}
								onChange={(e) => {
									this.setState({ search: e.target.value });
								}}
								placeholder='Search facility'
							/>
						</div> : null
					}
						{this.getOptions()}
					</ul>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/commons/NewDropSelector.js